/**
 * Analysis Dialog Store
 * Zustand store to open/close the new analysis dialog from anywhere
 */

import { create } from 'zustand';

interface AnalysisDialogState {
  /** Whether the analysis dialog is open */
  isOpen: boolean;
  /** Open the dialog */
  open: () => void;
  /** Close the dialog */
  close: () => void;
}

export const useAnalysisDialogStore = create<AnalysisDialogState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
